import Link from 'next/link'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { Trans, t } from '@lingui/macro'
import H1 from 'components/ui/H1'
import Header from 'components/ui/Header'

const SubjectsIndex = ({ items }) => {
  const { locale } = useRouter()

  return (
    <div className="container">
      <Head>
        <title key="title">
          {`${t`Subjects`} - ${process.env.NEXT_PUBLIC_SITE_TITLE}`}
        </title>
        <meta property="og:title" content={t`Subjects`} key="og:title" />
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_DOMAIN}${
            locale == 'en' ? `` : `/${locale}`
          }/subjects`}
          key="canonical"
        />
        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_DOMAIN}${
            locale == 'en' ? `` : `/${locale}`
          }/subjects`}
          key="og:url"
        />
      </Head>
      <Header>
        <H1>
          <Trans>Subjects</Trans>
        </H1>
      </Header>
      <div className="pb-10">
        {!!items.length && (
          <ul>
            {items.map((item) => (
              <li key={item.slug[locale].current}>
                <Link
                  href="/subjects/[slug]"
                  as={`/subjects/${
                    item.slug[locale]
                      ? item.slug[locale].current
                      : item.slug.en.current
                  }`}
                >
                  <a>{item.title[locale]}</a>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}
export default SubjectsIndex
